import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const typesMapping = {
    BOX: 'Caja',
    PALLET: 'Palets',
    PRODUCT: 'Producto'
}
class ConfigTag
{
    id = null;
    template_id = null;
    name = null;
    description = null;
    height = null;
    width = null;
    mem_epc = null;
    mem_user = null;
    variables = null;
    enabled = null;


    constructor(obj) {
	    // IF AN OBJECT WAS PASSED THEN INITIALISE PROPERTIES FROM THAT OBJECT
    	for (var prop in obj) this[prop] = obj[prop];
      }

    getLocationPanelView(){
        return {
            id: this.id,
            name: this.name,
        }
    }

    getDescriptionPanelView() {
        return [
            {
                title: i18n.t('packaging.type'),
                value: typesMapping[this.type]
            },
            {
                title: i18n.t("template.number"),
                value: this.name
            },
            {
                title: i18n.t("description"),
                value: this.description
            },
        ]
    }

    getPrintPanelView() {
        return [
            {
                title: i18n.t('height'),
                value: this.height
            },
            {
                title: i18n.t('width'),
                value: this.width
            },
            {
                title: i18n.t('epc.memory'),
                value: this.mem_epc
            },
            {
                title: i18n.t('user.memory'),
                value: this.mem_user
            },
        ]
    }

    getConfirmationView() {
        return [
            {
                step: i18n.t('description'),
                data: [
                    this.name,
                    this.description
                ]
            },
            {
                step: i18n.t('measures'),
                data: [
                    `${i18n.t('height')} ${this.height} ${i18n.t('unit.size.tag')}`,
                    `${i18n.t('width')} ${this.width} ${i18n.t('unit.size.tag')}`
                ]
            },
            {
                step: i18n.t('memory'),
                data: [
                    this.mem_epc,
                    this.mem_user
                ]
            },
        ]
    }

    getGenericTableView() {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            // dimensions: "Alto " + this.height + "mm | Ancho " + this.width + "mm",
            dimensions: `${capitalize(i18n.t('height'))} ${this.height} ${i18n.t('unit.size.tag')} | ${capitalize(i18n.t('widht'))} ${this.width} ${i18n.t('unit.size.tag')}`,
            memories: `${this.mem_epc}gb | ${this.mem_user}gb`,
            type: this.type,
            created_at: this.created_at,
        }
    }

}

class Tag
{
    //epc
    rfid = null;
    bar_code = null;
    serial_number = null;
    sku = null;
    variables = null;
    printed = null;
    enabled = null;
    config_tag = null;

    constructor(obj) {
	    // IF AN OBJECT WAS PASSED THEN INITIALISE PROPERTIES FROM THAT OBJECT
    	for (var prop in obj) this[prop] = obj[prop];
      }

}
export {
    ConfigTag,
    Tag
}
